// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import uuidv4 from 'uuid/v4';
import parse from 'html-react-parser';

import * as qualityGuidelinesActions from '../store/actions';
import * as globalActions from '../../../store/globalStore/actions';
import { getData } from '../store/selectors';
import Navigation from '../../../common/Navigation/Navigation';
import { PhotoDescriptionContainer } from '../components';
import styles from './styles';

class GuidelinesPage extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    setPage: PropTypes.func,
    requestPageData: PropTypes.func,
    data: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    setPage: () => { },
    requestPageData: () => { },
    data: {
      images: [],
    },
  };

  componentDidMount() {
    this.props.setPage({ current_page: 'Quality guidelines' });
    this.props.requestPageData();
  }

  componentWillUnmount() {
    this.props.setPage({ current_page: null });
  }

  render() {
    const { classes, data } = this.props;
    return (
      <Navigation mobileLikeIndex={false}>
        <div className={classes.mainContainer}>
          <div className={classes.subContainer}>
            <h4 className={classes.title}>{data.title}</h4>
            <div className={classes.photoDescriptionContainer}>
              {data.images.map(el => <PhotoDescriptionContainer key={uuidv4()} {...el} />)}
            </div>
            {data.paragraphs.length > 0 && (
              <div key={uuidv4()} className={classes.paragraphsContainer}>
                {parse(data.paragraphs[0].text)}
              </div>)}
            <div className={classes.paragraphsContainer}>
              {data.paragraphs.slice(1).map(el => (
                <div className={classes.paragraphContainer}>
                  <span className={classes.paragraphTitle}>{el.title}</span>
                  <span className={classes.paragraphText}>{parse(el.text)}</span>
                </div>))}
            </div>
          </div>
        </div>
      </Navigation>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: getData(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: page => dispatch(globalActions.setPage(page)),
    requestPageData: () => dispatch(qualityGuidelinesActions.requestPageData()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(GuidelinesPage));
